import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";
import { useLocalStorage } from "./LocalStorageHook";

export interface CustomerContact {
  [index: string]: string | boolean;
  isLoaded: boolean;
  first_name: string;
  last_name: string;
  email: string;
  mobile: string;
  phone: string;
  fax: string;
}

export default async function GetCustomerContact(
  salesOrg: string,
  guid: string
): Promise<CustomerContact[]> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/customer/contact/?customerNum=${guid}`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}
